<template>
  <Form
    class="flex flex-col gap-6 w-full"
    :resolver="employeeGivingResolver"
    :initialValues="initialValues"
    ref="employeeGivingForm"
    v-slot="$form"
    v-focustrap
    data-test="employeeGivingForm"
  >
    <LabeledField :field="$form.verificationType">
      <RadioButtonGroup
        name="verificationType"
        class="flex flex-wrap gap-4"
        data-test="verificationType"
      >
        <div class="flex items-center gap-2">
          <RadioButton
            inputId="employeeId"
            :value="6435"
          />
          <label for="employeeId">Verify with Employee ID</label>
        </div>
        <div class="flex items-center gap-2">
          <RadioButton
            inputId="verificationCompanyCode"
            :value="6436"
          />
          <label for="verificationCompanyCode">Verify with Company Code</label>
        </div>
        <div class="flex items-center gap-2">
          <RadioButton
            inputId="noVerification"
            :value="6437"
          />
          <label for="noVerification">Do not require verification</label>
        </div>
      </RadioButtonGroup>
    </LabeledField>

    <div
      v-show="$form.verificationType?.value === 6436"
      class="flex gap-x-4 w-full"
      data-test="verificationCompanyCodeContainer"
    >
      <LabeledField
        label="Company Code"
        :field="$form.verificationCompanyCode"
        data-test="verificationCompanyCode"
      >
        <InputText
          name="verificationCompanyCode"
          fluid
        />
      </LabeledField>
    </div>
  </Form>
</template>

<script setup>
import { ref, onMounted, computed, watchEffect } from 'vue';
import { z } from 'zod';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import { companyGivingVerificationType } from '@/helpers/enum.js';
import LabeledField from '@/components/forms/LabeledField.vue';

const employeeGivingForm = ref(null);
const employeeGivingResolver = zodResolver(
  z.object({
    verificationType: z.enum(Object.keys(companyGivingVerificationType)),
    verificationCompanyCode: z
      .string()
      .optional()
      .refine((val) => (val ? val.length >= 3 : true), 'Company code must be at least 3 characters'),
  }),
);

watchEffect(() => {
  if (
    employeeGivingForm.value?.states?.verificationType.value &&
    employeeGivingForm.value?.states?.verificationType.value != companyGivingVerificationType.COMPANY_CODE
  ) {
    employeeGivingForm.value.states.verificationCompanyCode.value = '';
  }
});

const companyAdminStore = useCompanyAdminStore();

const initialValues = computed(() => ({
  verificationType: companyAdminStore.company.verificationType || companyGivingVerificationType.EMPLOYEE_ID,
  verificationCompanyCode: companyAdminStore.company.verificationCompanyCode,
}));

onMounted(() => {
  companyAdminStore.employeeGivingForm = employeeGivingForm.value;
});
</script>
